import { DE, IT, US } from 'country-flag-icons/string/3x2';

// Convert the strings to Data URLs that the <img> src can read
const UsFlagStr = `data:image/svg+xml;utf8,${encodeURIComponent(US)}`;
const DeFlagStr = `data:image/svg+xml;utf8,${encodeURIComponent(DE)}`;
const ItFlagStr = `data:image/svg+xml;utf8,${encodeURIComponent(IT)}`;

export type Language = {
  code: string;
  id: number;
  name: string;
  flag: string;
  otherCodes?: string[];
};

export const languages: Language[] = [
  {
    code: 'en',
    id: 1,
    name: 'English',
    flag: UsFlagStr,
    otherCodes: ['en-US', 'en-GB']
  },
  {
    code: 'de',
    id: 2,
    name: 'German',
    flag: DeFlagStr
  },
  {
    code: 'it',
    id: 3,
    name: 'Italian',
    flag: ItFlagStr
  }
];
